import { LabeledOption } from '@e3dc-react/shell/Types/globalTypes'
import { PlatformType, NotificationType } from './models/notifications.model'
import { NotificationUserLevel } from './types'

export const PLATFORM_OPTIONS: LabeledOption<string>[] = [
  { value: PlatformType.Mobile, label: 'notifications.platform.mobile' },
  { value: PlatformType.Desktop, label: 'notifications.platform.desktop' },
  { value: PlatformType.Both, label: 'notifications.platform.both' },
]

export const NOTIFICATION_TYPE_OPTIONS: LabeledOption<string>[] = [
  { value: NotificationType.Optional, label: 'notifications.type.optional' },
  { value: NotificationType.Mandatory, label: 'notifications.type.mandatory' },
]

export const NOTIFICATION_USER_LEVEL_OPTIONS: LabeledOption<NotificationUserLevel>[] = [
  { value: 'ALL', label: 'common.all' },
  { value: 'USER', label: 'framework.userBadge.userlevel.end-user' },
  { value: 'PARTNER_AND_INSTALLER', label: 'framework.userBadge.userlevel.partner-and-installer' },
  { value: 'INTERNAL', label: 'notifications.form.internal' },
]

export const NOTIFICATION_LIMIT = 10

export const RESTRICTED_ROUTES_TO_DISPLAY_NOTIFICATIONS = ['/notifications', '/message-of-the-day']
